// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiMedical {
    static getAttributeTypeMap() {
        return MedicalBiMedical.attributeTypeMap;
    }
}
MedicalBiMedical.discriminator = undefined;
MedicalBiMedical.additionalProperties = false;
MedicalBiMedical.attributeTypeMap = [
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "groupPhone",
        "baseName": "groupPhone",
        "type": "string"
    },
    {
        "name": "policyAvailableOnWebsite",
        "baseName": "policyAvailableOnWebsite",
        "type": "string"
    },
    {
        "name": "policyNumber",
        "baseName": "policyNumber",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiMedical.js.map